import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-3 mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              Trending Categories
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              Hand-picked for you — every category updated weekly
            </p>
          </div>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            View All Categories →
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-xl overflow-hidden h-56 cursor-pointer block"
              data-product-shop
            >
              <img
                src={cat.image}
                alt={`${cat.name} category - Sugargoo Spreadsheet`}
                title={`${cat.name} - Sugargoo Spreadsheet`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>
              <div className="absolute top-3 right-3">
                <span className="px-2.5 py-1 bg-foreground-950/70 backdrop-blur-sm text-background-50 text-xs font-medium rounded-full">
                  {cat.name}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <p className="text-background-50 text-sm font-medium">
                  {cat.name}
                </p>
                <p className="text-background-50/70 text-xs mt-1">
                  {cat.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}